<template>
  <div class="about">

    <div style="position: relative;font-size: 0;border-bottom: 1px solid #f1f1f1;">
      <div style="padding-bottom: 55%;background: #ffffff;">
        <div class="ab-t-t-x-y">
          <img :src="detail.visit_cover_img" width="80%;"/>
        </div>
      </div>


      <div style="position: absolute;left: 16px;top: 16px;" @click="goBack">
        <div style="width: 36px;height: 36px;background: #7e7e7e;border-radius: 100%;text-align: center;line-height: 36px;color: #ffffff;font-size: 20px;">
          <van-icon name="arrow-left" style="line-height: 36px;"/>
        </div>
      </div>
    </div>

    <div class="detail-block">
      <div class="detail-title t-al-l" style="font-size: 18px;font-weight: bold;color: rgb(255,120,12)">
        {{detail.tit}}
      </div>

      <div style="font-size: 14px;color: #222222;text-align: left;margin-top: 24px;">
        转让价：<span style="font-size: 18px;color: rgb(255,120,12)">{{detail.now_price}}</span>
      </div>
    </div>


    <div class="detail-block">
      <div class="detail-title t-al-l" style="font-size: 18px;">
        商标信息
      </div>
    </div>

    <div class="detail-block">
      <div style="font-size: 14px;line-height:30px; color: #959595;text-align: left;" v-if="!detail.is_intel">
        有效期限：{{detail.valid_date}}<br/>
        所属类别：{{detail.classify}}类 - {{detail.classify_name}}<br/>
        类似群组：{{detail.analogues_group}}<br/>
        适用项目：{{detail.fit_projects}}<br/>
      </div>

      <div style="font-size: 14px;line-height:30px; color: #959595;text-align: left;" v-else>
        所属类别：{{detail.classify}}类 - {{detail.classify_name}}<br/>
      </div>
    </div>

    <div class="detail-block">
      <div class="detail-title t-al-l" style="font-size: 18px;">
        转让流程
      </div>
    </div>

    <div class="detail-block">
      <img src="../assets/images/tran1.png" style="width: 100%;margin-top: 10px;"/> <br/>

        <img src="../assets/images/tran1.png" style="width: 100%;margin-top: 10px;"/>
    </div>


    <div class="detail-block">
      <div class="detail-title t-al-l" style="font-size: 18px;">
        我们的承诺
      </div>
    </div>


    <div class="detail-block">
      <img src="../assets/images/commitment.png" style="width: 100%;margin-top: 10px;"/>
    </div>

    <div class="detail-block">
      <div class="detail-title t-al-l" style="font-size: 18px;">
        过户资料
      </div>
    </div>

    <div class="detail-block" style="border: none !important;padding-top: 24px;">
      <table style="font-size: 12px;">
        <tr>
          <th>个人用户</th>
          <th>企业用户</th>
          <th>麦汇平台</th>
          <th>过户完成</th>
        </tr>
        <tr>
          <td>身份证/个体户营业执照
          </td>
          <td>企业营业执照</td>
          <td>商标代理委托书/转让申请书/转让协议
          </td>
          <td>国家商标局下发商标转让受理通知书/核准转让证明/商标证书</td>
        </tr>
      </table>
    </div>


    <div style="height: 80px;background-color: #ffffff;"></div>
  </div>
</template>


<style scoped>
table{border-collapse: collapse;}
  th, td {
    width: 25%;
    border:1px solid #f1f1f1;
    line-height: 18px;
    padding: 6px;
    text-align: left;
  }

</style>

<style>

.detail-block
{
  padding:12px 14px;
  border-bottom: 1px solid #f1f1f1;
  background-color: #ffffff;
}


.service-block
{
  padding: 16px;
}

.time-text
{
  font-size: 0.4rem;
  color:#000000;
}

.price-text
{
  font-size: 0.7rem;
  color:#000000;
}

.desc-text
{
  font-size: .45rem;
  color: #222222;
  line-height: .675rem;
}

.service-item
{
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px;
  position: relative;
  min-height: 70px;
  margin-top: 12px;
}

.service-item:after{
  content: "立即办理";
  font-size: 12px;
  background-color: #da4725;
  color:#ffffff;
  line-height: 40px;
  height: 40px;
  border-top-left-radius: 40px;
  border-bottom-left-radius: 40px;
  text-align: center;
  width: 100px;
  display: block;
  right: 0;
  top: 40px;
  position: absolute;
}

.service-title{
  font-size: 14px !important;
  line-height: 24px;
  color: #5f5ea9;
  font-weight: bold;
  text-align: left;
}

.service-price
{
  font-size: 16px !important;
  line-height: 24px;
  color: #f15422;
  font-weight: 500;
  text-align: right;
}

.service-p{
  padding-left: 16px;
  position: relative;
  font-size: 12px;
  color: #989898;
  line-height: 18px;
  text-align: left;
  margin-top: 8px;
  padding-right: 85px;
}

.service-p:before
{
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 100%;
  background: #5f5ea9;
  display: block;
  left: 4px;
  top: 6px;
  position: absolute;
}

</style>
<script>
import common from '../assets/js/common'
import addone from '../components/addone'
import _ from 'underscore'

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  components:
      {
        addone
      },
  data: function(){
    return {
      list_combine:[],
      active:0,
      id: '',
      detail: ''
    }
  },
  methods:{
    initPage:function()
    {
      common.cusHttp(this,'/boot/product.php',{action:'detail', 'id': this.id }, 'get').then((res)=>{
        res = JSON.parse(res.data)
        if( res.status ) {
          this.detail = res.data;
          console.log(this.detail)
        }
      })
    },
    goBack()
    {
      //返回功能
      if (window.history.length <= 1) {
        this.$router.push({ path: "collection" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },
    goDetail(item)
    {
      this.$router.push({ path: '/service_detail', query: { id: item }})
    },
    goService()
    {
      this.$router.push({ path: '/collection'})
    }
  },
  created:function()
  {
    /**
     * 如果没有token则跳到登录页哟
     */
    common.checkToken(this)

    common.setTitle('确认信息');
    this.id = common.getUrlParam('id');
  },
  mounted()
  {

    console.log('查看')
    console.log(this.id)

    this.$store.commit('setTarbarIndex',1)
    this.initPage();
  },
  onShow()
  {
  },
  computed:{
    currentListCombine:function()
    {
      var _self = this;
      var subList = _.filter(this.list_combine,function(item){

        if( _self.active == 0 )
        {
          return true;
        }


        if ( _self.active == item.status )
        {
          return true;
        }
        return false;
      })
      console.log('合并列表')
      console.log(subList)
      return subList;
    }
  }
}
</script>